export default class CouldNotDeleteFolderError extends Error {}
